

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Inputmask from 'inputmask';

import { getValidationErrorText } from '@/utils/validate';
import { MIN_DATE } from '@/utils/services';

@Component({
  data: () => ({ getValidationErrorText }),
  inheritAttrs: false,
})
export default class DateFieldCustom extends Vue {
  $refs!: {
    textField: any;
  };
  @Prop() private value!: string;
  @Prop() private label!: string;
  @Prop() private min!: string;
  @Prop() private dense!: boolean;
  @Prop() private clearable!: boolean;
  @Prop() private hideDetails!: boolean;
  @Prop({ type: Boolean, default: false }) private closeOnContentClick = false;
  @Prop({ type: Boolean, default: false }) private disabled?: boolean;
  @Prop({ type: Boolean, default: false }) private readonly?: boolean;
  @Prop() private errorMessage?: Function;

  show = false;

  get minDate() {
    return this.min ?? MIN_DATE;
  }

  MIN_DATE = MIN_DATE;

  mounted() {
    Inputmask({
      alias: 'datetime',
      inputFormat: 'dd.mm.yyyy',
      showMaskOnHover: false,
      placeholder: 'дд.мм.гггг',
    }).mask(this.$refs.textField.$refs.input);
  }

  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('change', value);
  }

  get modelDatePicker() {
    if (!this.model) return new Date().toISOString();

    const [day, month, year] = this.model.split('.');

    try {
      if (
        year.length !== 4 ||
        isNaN(+year) ||
        month.length !== 2 ||
        day.length !== 2 ||
        isNaN(Date.parse(`${year}-${month}-${day}`))
      ) {
        return undefined;
      }
    } catch {
      return undefined;
    }

    return `${year}-${month}-${day}`;
  }

  set modelDatePicker(value) {
    if (!value) return;

    const [year, month, day] = value.split('-');

    this.model = `${day}.${month}.${year}`;
  }

  @Watch('model')
  onChangeModel(value: string) {
    this.$emit('input', value);
  }

  keydownHandler(event: KeyboardEvent) {
    if (event.key === 'Enter') this.show = false;
  }
}
